




















import Vue from "vue";
import { Computed, Data, Method, Props } from "./formQuestionTypes";
import { mapMutations, mapState } from "vuex";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-cancel-survey-form-question",

  data: function() {
    return {
      additionalComment: ""
    };
  },
  computed: {
    ...mapState("cancelSurveyForm", ["results"])
  },
  props: {
    question: {},
    parentQuestionId: { default: -1 },
    choiceId: { default: -1 }
  },

  methods: {
    ...mapMutations("cancelSurveyForm", ["updateResults"]),

    changeAdditionalComment() {
      const result = {
        parentQuestionId: this.parentQuestionId,
        questionId: this.question.questionId,
        choiceId: this.choiceId,
        additionalComment: this.additionalComment
      };
      this.updateResults({ index: this.parentQuestionId, result: result });
    }
  }
});
